var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Transaction } from "./Transaction.js";
/**
 * A list associated with a transaction query.
 *
 * @public
 */
export class TransactionList {
    constructor(book, payload) {
        this.book = book;
        this.payload = payload || {};
    }
    /**
     * Gets the cursor associated with the query for pagination.
     *
     * @returns The cursor associated with the query for pagination
     */
    getCursor() {
        return this.payload.cursor;
    }
    /**
     * Retrieves the account associated with the query, when filtering by account.
     *
     * @returns The account associated with the query, or undefined if not set
     */
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.payload.account) {
                return undefined;
            }
            return yield this.book.getAccount(this.payload.account);
        });
    }
    /**
     * Gets the first Transaction in the list.
     *
     * @returns The first Transaction in the list
     */
    getFirst() {
        const transactions = this.getItems();
        return transactions.length > 0 ? transactions[0] : undefined;
    }
    /**
     * Gets the total number of transactions in the list.
     *
     * @returns The total number of transactions
     */
    size() {
        var _a;
        return ((_a = this.payload.items) === null || _a === void 0 ? void 0 : _a.length) || 0;
    }
    /**
     * Gets the transactions in the list.
     *
     * @returns An array of Transaction objects
     */
    getItems() {
        var _a;
        let transactions = [];
        for (let transaction of (_a = this.payload.items) !== null && _a !== void 0 ? _a : []) {
            transactions.push(new Transaction(this.book, transaction));
        }
        return transactions;
    }
}
//# sourceMappingURL=TransactionList.js.map